module.exports = __webpack_public_path__ + "fonts/Segoe UI Bold.ce4ba28.woff2";